<template lang="pug">
  div.select(:class="{'has-error': hasError}" :style="combineStyles")
    slot(name="label" v-bind:label="label" v-if="label")
      label.input-field__label(v-if='required')
        | {{label + ' '}}
        span.input-field__label-tooltip * <span>Обязательное поле</span>
      label.input-field__label(v-else) {{label}}
    v-select(v-bind="vSelectParams" v-model="selected" @input="setSelected")
      // template(v-slot:selected-option-container="selected")
        div {{selected}} --
      // template(v-slot:selected-option="option" v-bind="(typeof option === 'object')?option:{[label]: option}")
        | {{ option.label }} ----
      template(v-if="isMultiple" v-slot:option="option")
        span.select-multi-opt(@click="optionClickHandler(option)")
          span.select-checked-opt(:class="[{'is-selected': option.isSelected}]" )
          | {{ option.label }}
    div.select__error(v-if="hasError")
      | {{errorMessage}}
</template>

<script>
  // vendor
  import vSelect from 'vue-select';
  import _isEqual from 'lodash/isEqual';
  import _clone from 'lodash/clone';
  import _findIndex from 'lodash/findIndex';

  // mixins
  import fieldProps from '@/mixins/fieldProps';
  import checkConditions from '@/mixins/questionConditions';
  import combineStyles from '@/mixins/combineStyles';

  // assets
  import toggleArrow from './assets/toggle-arrow.svg'

  vSelect.props.components.default = () => ({
    OpenIndicator: {
      render: createElement => createElement('img', {
        attrs: {
          src: toggleArrow
        }
      })
    },
    Deselect: {
      render: createElement => createElement(null)
    }
    // Deselect: {
    //   render: createElement => createElement('img', {
    //     attrs: {
    //       src: close
    //     }
    //   })
    // }
  })
  // TODO: если будет id у option - заменить isEqual на сравнение id
  export default {
    name: 'Select',
    mixins: [fieldProps, checkConditions, combineStyles],
    components: {
      'v-select': vSelect
    },
    props: {
      selectedOpts: {
        type: Array,
        default: () => ([])
      },
      isMultiple: {
        type: Boolean,
        default: false
      },
      options: {
        type: Array,
        default: function () {
          return []
        }
      }
    },
    methods: {
      validator () {
        this.hasError = this.selected.length < 1;
      },
      optionClickHandler: function (option) {
        const options = _clone(this.vSelectParams.options);
        const optionsIdx = _findIndex(options, (o) => {
          return _isEqual(option, o);
        });

        if (!option.isSelected) {
          options[optionsIdx].isSelected = true;
          this.$forceUpdate();
        } else {
          const selected = _clone(this.selected);
          const selectedIdx = _findIndex(selected, (o) => {
            return _isEqual(option, o);
          });
          options[optionsIdx].isSelected = false;
          selected.splice(selectedIdx, 1);
          this.selected = selected;
          this.setSelected(this.selected);
        }

        if (this.$props.dependent) {
          this.$props.dependent.map(() => {
            this.$store.dispatch('conditions/changeConditionState', { value: this.selected, name: this.name });
          })
        }
      },
      setSelected (value) {
        // TODO: изменит ответ api чтобы вот это на фронте не делать
        if (this.$props.isMultiple) {
          for (let i = 0; i < value.length; i++) {
            value[i].name = this.$props.name;
          }
        } else {
          value.name = this.$props.name;
        }

        const answer = {
          pollId: this.$props.pollId,
          question: this.$props.question,
          options: this.$props.isMultiple ? this.selected : [this.selected]
        };

        this.$store.dispatch('answers/addRemoveAnswer', answer);

        this.validator();
        if (this.hasError) {
          return false;
        }

        if (this.$props.dependent && !this.$props.isMultiple) {
          this.$props.dependent.map(() => {
            this.$store.dispatch('conditions/changeConditionState', answer.options);
          })
        }
      }
    },
    data: function () {
      return {
        hasError: false,
        errorMessage: this.$props.input_type ? this.$props.input_type.error : '',
        selected: this.$props.selectedOpts,
        count: 0,
        vSelectParams: {
          searchable: false,
          multiple: this.$props.isMultiple,
          closeOnSelect: !this.$props.isMultiple,
          options: this.$props.options,
          placeholder: this.$attrs.placeholder
        }
      }
    }
  }
</script>

<style lang="scss" src="./assets/select.scss"></style>
